import { ProductFiltersDesktop } from "@/components/ProductFiltersSidebar";

/** Shared desktop filter panel for experts list tabs. */
export default function buildFilterSidebar({
  allFilters,
  validatedFilters,
  toggleFilter,
  resetFilters,
  contentAfterTop = null
}) {
  return (
    <ProductFiltersDesktop
      allFilters={allFilters}
      validatedFilters={validatedFilters}
      toggleFilter={toggleFilter}
      onReset={resetFilters}
      filtersTitle="Filters"
      contentAfterTop={contentAfterTop}
    />
  );
}
